"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const ActorTime = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 17,
  viewBox: "0 0 16 17",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#clip0_28_23975)"
}, /*#__PURE__*/_react.default.createElement("path", {
  className: "stroke",
  d: "M15.71 8.04a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
  stroke: "#1973E8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M8.21 14.04a6 6 0 100-12 6 6 0 000 12z",
  fill: "#1973E8"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: 7.5,
  y: 7.54,
  width: 9,
  height: 9,
  rx: 4.5,
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M12 9.707a2.333 2.333 0 100 4.667 2.333 2.333 0 000-4.667zM8.333 12.04a3.667 3.667 0 117.334 0 3.667 3.667 0 01-7.334 0zm4.334-1.498v1.222l.942.943-.942.942-1.334-1.333v-1.775h1.334z",
  fill: "#1973E8"
})));
var _default = exports.default = ActorTime;